export default __webpack_public_path__ + "static/media/logo.30d02137.png";